// extracted by mini-css-extract-plugin
export default {"hideNav":"styles_hideNav__RVnXe"};